<script setup>
</script>
<template>
  <div id="container" v-if="fetch_data">
    <section id="sales_movie">
      <div class="wrap">

        <div class="cts_box mb20">
          <h2 class="main_ttl"><span>動画レンタル</span></h2>
          <p class="lead_txt">
            複眼経済塾の動画講義を<span>リーズナブルな価格</span>で個別にご受講いただくことが可能になりました！<br>
            <span>レンタルビデオ方式</span>でご購入から<span>3か月間視聴</span>いただけます。<br>
            これから入塾をご検討の方や、上のクラスの講義を個別にご覧いただきたい方にお勧めです。
          </p>
        </div>

        <div class="sales_movie_wrap">
          <h2 class="sub_ttl"><span>動画一覧</span></h2>
          <div class="checkbox">
            <input id="check01" type="checkbox" v-model="only_bought" value="true" @change="onlyBoughtClicked()">
            <label for="check01">レンタル中動画のみ表示</label>
          </div>
          <template v-for="category in fetch_data">
            <div :key="category.id" v-if="category.sns_post_sales.length > 0" class="cat_box">
              <div class="cat_label">{{ category.name }}</div>
              <div class="movie_list_wrap">
                <ul class="movie_list">
                  <li class="movie_box" v-for="model in category.sns_post_sales" :key="model.id"
                      @click="openModal(model)">
                    <template v-if="model.sns_post_bought">
                      <span class="label" v-if="model.sns_post_readable">レンタル中
                        （{{ model.access_period === 'access_period_no_7_days' ? moment(model.access_period_at, 'YYYY年M月D日まで') : '無期限'}}）
                      </span>
                      <span class="label green" v-else>再レンタル</span>
                    </template>
                    <a href="javascript:void(0);">
                      <div class="thumb">
                        <img v-bind:src="model.video_picture_url" alt="">
                      </div>
                      <h3>{{ model.title }}</h3>
                    </a>
                  </li>
                </ul>
              </div>

            </div>
          </template>
        </div>
        <div class="button_wrap">
          <router-link :to="{ name: 'SnsPostSalesHistories'}" class="submit light skeleton">動画レンタル履歴</router-link>
        </div>

        <!-- modal -->
        <div class="modal movie open" v-if="model">
          <div class="modal_box">
            <div class="close modal_close" @click="closeModal()"></div><!--クリックで閉じる-->
            <div class="inner">
              <div class="scroll_wrap">
                <div class="scroll_box">
                  <div class="movie_details flex">
                    <div class="movie_inline">
                      <div class="iframe">
                        <!--サンプル動画有りの時だけvimeoのiframeタグをここに入れる-->
                        <span v-html="model.sample_vimeo_embed" v-if="model._show_sample_vimeo"></span>
                        <div class="poster" v-else>
                          <img v-bind:src="model.video_picture_url" alt="">
                        </div>
                      </div>
                      <div class="date flex">
                        <div class="link-btn play_btn" v-if="model.sample_vimeo_id" @click="playSampleVimeo()">
                          サンプル動画
                        </div><!--クリックでposterをdisplay:noneにしてvimeo iframeを再生 / サンプル動画無しで非表示-->
                        <p class="day">配信日：{{ moment(model.start_at, 'YYYY年M月D日') }}</p><!--配信日を取得して表示-->
                      </div>
                    </div>
                    <div class="details_txt">
                      <h3>{{ model.title }}</h3>
                      <ul class="class_tag_list">
                        <li class="tag class02" v-if="model.rank_regular">本科</li>
                        <li class="tag class03" v-if="model.rank_preparatory">予科</li>
                        <li class="tag class04" v-if="model.rank_general">一般</li>
                        <li class="tag class05" v-if="model.rank_student">学生科</li>
                        <li class="tag class06" v-if="model.rank_corporation">法人科</li>
                        <li class="tag class07" v-if="model.rank_free">ゲストユーザー</li>
                      </ul>
                      <div class="mov_txt">
                        <p v-html="queryMarker(model.description, '')"></p>
                      </div>
                      <template v-if="model.sns_post_readable">
                        <!-- レンタル中 -->
                        <p class="price">
                          <span class="red">レンタル中</span>
                            （視聴可能期間 {{ model.access_period === 'access_period_no_7_days' ? moment(model.access_period_at, 'YYYY年M月D日まで') : '無期限'}}）
                        </p>
                        <router-link :to="{ name: 'SnsPost', params: {post_id: model.sns_post_id} }" class="link-btn">
                          視聴する
                        </router-link>
                      </template>
                      <template v-else-if="model.sns_post_bought">
                        <!-- 過去にレンタルあり -->
                        <p class="price">&yen;{{ delimited(model.rank_price) }}
                          （視聴可能期間 {{ model.access_period === 'access_period_no_7_days' ? '3ヶ月' : '無期限'}}）
                        </p>
                        <router-link :to="{ name: 'SnsPostSale', params: {id: model.id} }" class="link-btn green">
                          再レンタルする
                        </router-link>
                      </template>
                      <template v-else>
                        <!-- 新規レンタル -->
                        <p class="price">&yen;{{ delimited(model.rank_price) }}
                          （視聴可能期間 {{ model.access_period === 'access_period_no_7_days' ? '3ヶ月' : '無期限'}}）
                        </p>
                        <router-link :to="{ name: 'SnsPostSale', params: {id: model.id} }" class="link-btn">
                          レンタルする
                        </router-link>
                      </template>
                      <p class="caution">※過去にレンタルしたことのある動画はボタンが「再レンタルする」となります。</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="ovr"></div>
        </div>
        <!-- //modal-->

      </div>
    </section>
  </div>
</template>

<script>
import Libraries from '@/components/Libraries.vue'

export default {
  mixins: [Libraries],
  data() {
    return {
      fetch_data_all: null,
      fetch_data_only_bought: null,
      fetch_data: null,
      model: null,
      only_bought: false
    }
  },
  mounted() {
    this.fetchData()
  },
  methods: {
    onlyBoughtClicked() {
      this.fetch_data = null
      this.$nextTick(() => {
        if (this.only_bought) {
          this.fetch_data = this.fetch_data_only_bought
        } else {
          this.fetch_data = this.fetch_data_all
        }
        this.$nextTick(() => {
          this.fetchDone()
        })
      })
    },
    openModal(m) {
      this.model = m
      this.model._show_sample_vimeo = false
    },

    closeModal() {
      this.model = null
    },

    playSampleVimeo() {
      this.model._show_sample_vimeo = true
      this.$forceUpdate()
      setTimeout(() => {
        try {
          const vimeo = new Vimeo.Player(`vimeo-${this.model.sample_vimeo_id}`)
          vimeo.play()
        } catch (e) {
          console.error(e)
        }
      }, 100)
    },

    fetchData() {
      this.startAjax()
      this.axios
          .get(`${this.env.api_base_url}sns/sns_post_sales.json`, {})
          .then(response => {
            this.fetch_data_all = response.data
            this.fetch_data_only_bought = JSON.parse(JSON.stringify(response.data))
            for (const category of this.fetch_data_only_bought) {
              const _sns_post_sales = []
              for (const model of category.sns_post_sales) {
                if (model.sns_post_readable) {
                  _sns_post_sales.push(model)
                }
              }
              category.sns_post_sales = _sns_post_sales
            }
            if (this.only_bought) {
              this.fetch_data = this.fetch_data_only_bought
            } else {
              this.fetch_data = this.fetch_data_all
            }
          })
          .catch((response) => {
            this.errorAjax(response)
          })
          .finally(() => {
            this.fetchDone()
            this.finishAjax()
          })
    },
    fetchDone() {
      window.$('.movie_list').each(function () {
        window.$(this).slick({
          autoplay: false,
          fade: false,
          dots: false,
          arrows: true,
          slidesToShow: 3,
          slidesToScroll: 3,
          responsive: [{
            breakpoint: 767,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 2
            }
          }]
        });
      });
    },

  }
}
</script>

<style lang="scss">
.order_group.expire {
  opacity: 0.8;
  background: #eee;
  pointer-events: none;
}

</style>